import gql from "graphql-tag";

const BMIProps = gql`
	fragment BMIProps on BMI {
		id
		lossWeight
		weight
		height
		bmi
		created_at
	}
`;
const LIST = gql`
	query GetBmiList($id: ID!) {
		GetBMIList(patient: $id) {
			docs {
				...BMIProps
			}
		}
	}
	${BMIProps}
`;

const CREATE = gql`
	mutation NewBMI($model: BMIInput!) {
		RecordBMI(model: $model) {
			message
			doc {
				...BMIProps
			}
		}
	}
	${BMIProps}
`;

export { LIST, CREATE };
